export default __webpack_public_path__ + "static/media/2.9fe85260.wav";